var number = Number.prototype.toLocaleString.call(4.5);
var decimalSplitter = number.charAt(1);
module.exports = decimalSplitter;